import types from './types';

const INITIAL_STATE = {
  isFetching: false,

  result: [],
};

const authOBCodesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_OB_CODES_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_OB_CODES_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_OB_CODES_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
    };

  default:
    return state;
  }
};

export default authOBCodesReducer;
